import ModalCustom from '../../UI/modal';
import AddForm from '../../forms/add-form';
import { useTrip } from '../../contexts/trip-context';

type Props = {
  show: boolean;
  handleClose: () => void;
  tripId?: string;
  folderId?: string;
};
const AddFolderModal = ({
  show,
  handleClose,
  folderId: propFolderId,
  tripId: propTripId
}: Props) => {
  const { trip, activeFolderIds } = useTrip();

  // Use context mode if props are not provided
  const tripId = propTripId || trip?.id || '';
  const folderId =
    propFolderId ||
    (activeFolderIds && activeFolderIds.length > 0 ? activeFolderIds[0] : '') ||
    '';

  return (
    <ModalCustom
      show={show}
      onHide={handleClose}
      title='Add Folder'
      paddingBody='30px 32px 32px'
    >
      <AddForm
        label='Folder Name'
        placeholder='Enter folder name'
        submitTitle='Add Folder'
        parentFolderId={folderId}
        tripId={tripId}
      />
    </ModalCustom>
  );
};
export default AddFolderModal;
